import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  oAuthGoogleSolicitarAcceso
} from "@fixeduy/restaurantestypes";

const oAuthGoogleGenerarURLLectorMails = async (
  params: oAuthGoogleSolicitarAcceso
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "oAuthGoogleGenerarURLLectorMails",
    params: params
  });
  return result.data;
};

export { oAuthGoogleGenerarURLLectorMails };
